import styled from '@emotion/styled';

export const TableWrapper = styled('div')(
  (props: { rowFill: 'odd' | 'even' | 'none' }) => ({
    border: '1px solid #D9E4F5',
    borderRadius: '1rem',
    '& div:first-child': {
      borderRadius: '1rem 1rem 0 0',
    },
    '& div:nth-of-type(odd)': {
      backgroundColor: props.rowFill === 'odd' ? '#F5F6F8' : '#fff',
      borderBottom: '1px solid #D9E4F5',
    },
    '& div:nth-of-type(even)': {
      backgroundColor: props.rowFill === 'even' ? '#F5F6F8' : '#fff',
      borderBottom: '1px solid #D9E4F5',
    },
    '& div:last-child': {
      borderRadius: '0 0 1rem 1rem',
      borderBottom: 'none',
    },
  }),
);

export const RowWrapper = styled('div')(
  (props: { columnsTemplate: string }) => ({
    padding: '1rem',
    display: 'grid',
    gridTemplateColumns: props.columnsTemplate,
    columnGap: '0.5rem',
  }),
);
